DJ.addBehavior('share-link', '.share-link', {
  attach: function(context, settings, behavior) {
    var $shareLink = jQuery(this);
    var $button = $shareLink.find('.js-share-button');
    var $hidden = $shareLink.find('.share-link__hidden');

    // S'assurer qu'au moins une classe d'état est présente
    if (!$shareLink.hasClass('opened') && !$shareLink.hasClass('closed')) {
      $shareLink.addClass('closed');
    }

    // Convertir les liens en boutons pour l'accessibilité (rétrocompatibilité)
    if ($button.is('a')) {
      var $newButton = jQuery('<button>', {
        type: 'button',
        class: $button.attr('class'),
        html: $button.html()
      });
      $button.replaceWith($newButton);
      $button = $newButton;
    }

    // S'assurer que les attributs ARIA sont présents
    if (!$button.attr('aria-controls')) {
      var shareId = $hidden.attr('id') || 'share-link-' + Math.random().toString(36).substr(2, 9);
      if (!$hidden.attr('id')) {
        $hidden.attr('id', shareId);
      }
      $button.attr('aria-controls', shareId);
    }

    // Ajouter un texte accessible si absent
    if (!$button.find('.visually-hidden').length) {
      $button.append('<span class="visually-hidden">Afficher les options de partage</span>');
    }

    // Fonction pour mettre à jour le texte accessible selon l'état
    var updateAccessibleText = function(isOpen) {
      var $accessibleText = $button.find('.visually-hidden');
      if ($accessibleText.length) {
        $accessibleText.text(isOpen ? 'Fermer les options de partage' : 'Afficher les options de partage');
      }
    };

    // Initialiser l'état ARIA selon les classes CSS
    var isOpen = $shareLink.hasClass('opened');
    $button.attr('aria-expanded', isOpen ? 'true' : 'false');
    $hidden.attr('aria-hidden', isOpen ? 'false' : 'true');
    updateAccessibleText(isOpen);

    // Fonction pour extraire le nom du réseau depuis la classe ou data-name
    var getNetworkName = function($link) {
      // Mapping des noms de réseaux pour une meilleure présentation
      var networkNames = {
        'x': 'X',
        'facebook': 'Facebook',
        'linkedin': 'LinkedIn',
        'twitter': 'Twitter',
        'email': 'Email',
        'whatsapp': 'WhatsApp',
        'pinterest': 'Pinterest',
        'reddit': 'Reddit',
        'telegram': 'Telegram'
      };

      // Essayer d'abord data-name
      var dataName = $link.attr('data-name');
      if (dataName) {
        var lowerName = dataName.toLowerCase();
        return networkNames[lowerName] || dataName.charAt(0).toUpperCase() + dataName.slice(1);
      }

      // Sinon, extraire depuis la classe (ex: a2a_button_x -> X, a2a_button_facebook -> Facebook)
      var classes = $link.attr('class') || '';
      var match = classes.match(/a2a_button_(\w+)/);
      if (match) {
        var network = match[1].toLowerCase();
        return networkNames[network] || network.charAt(0).toUpperCase() + network.slice(1);
      }

      return 'réseau social';
    };

    // Fonction pour transformer le markup AddToAny en structure accessible
    var makeSocialIconsAccessible = function() {
      var $socialIcons = $shareLink.find('.social-icons');
      if (!$socialIcons.length) {
        return;
      }

      // Vérifier si déjà transformé (contient déjà un ul)
      if ($socialIcons.find('ul').length) {
        return;
      }

      // Récupérer tous les liens qui ne sont pas déjà dans un ul > li
      var $allLinks = $socialIcons.find('a');
      var $links = $allLinks.filter(function() {
        // Exclure les liens qui sont déjà dans un ul > li
        return !jQuery(this).closest('ul > li').length;
      });

      if ($links.length === 0) {
        return;
      }

      // Créer la structure ul
      var $ul = jQuery('<ul>');

      // Pour chaque lien, créer un li et ajouter le title
      $links.each(function() {
        var $link = jQuery(this);
        var networkName = getNetworkName($link);
        var title = 'Partager ce contenu sur ' + networkName;

        // Ajouter le title au lien
        $link.attr('title', title);

        // S'assurer que les images ont aria-hidden
        $link.find('img').attr('aria-hidden', 'true');

        // Créer le li et y mettre le lien
        var $li = jQuery('<li>');
        $li.append($link);
        $ul.append($li);
      });

      // Récupérer les attributs du span original (data-a2a-url, data-a2a-title, etc.)
      var spanAttrs = {};
      if ($socialIcons[0] && $socialIcons[0].attributes) {
        // Convertir NamedNodeMap en tableau pour pouvoir utiliser forEach
        Array.from($socialIcons[0].attributes).forEach(function(attr) {
          spanAttrs[attr.name] = attr.value;
        });
      }

      // Créer un nouveau conteneur avec la structure ul
      var $newContainer = jQuery('<span>', {
        class: $socialIcons.attr('class'),
        style: $socialIcons.attr('style')
      });

      // Copier tous les attributs data
      jQuery.each(spanAttrs, function(name, value) {
        if (name.startsWith('data-') || name === 'class' || name === 'style') {
          $newContainer.attr(name, value);
        }
      });

      $newContainer.append($ul);

      // Remplacer l'ancien conteneur
      $socialIcons.replaceWith($newContainer);
    };

    // Ajouter aria-hidden="true" sur les images des icônes sociales (décoratives)
    var setSocialIconsAria = function() {
      $shareLink.find('.social-icons a img').attr('aria-hidden', 'true');
    };

    // Fonction pour traiter les icônes sociales (structure + aria)
    var processSocialIcons = function() {
      makeSocialIconsAccessible();
      setSocialIconsAria();
    };

    // Initialiser dès maintenant
    processSocialIcons();

    // Observer les changements dans .share-link__hidden (pour AddToAny qui charge dynamiquement)
    // On observe le parent plutôt que .social-icons car il peut être remplacé
    if ($hidden.length) {
      var observer = new MutationObserver(function(mutations) {
        // Vérifier si des changements ont été faits dans .social-icons
        var hasChanges = false;
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].target.classList && mutations[i].target.classList.contains('social-icons')) {
            hasChanges = true;
            break;
          }
          // Vérifier aussi les enfants ajoutés
          if (mutations[i].addedNodes && mutations[i].addedNodes.length > 0) {
            for (var j = 0; j < mutations[i].addedNodes.length; j++) {
              var node = mutations[i].addedNodes[j];
              if (node.nodeType === 1 && (node.classList.contains('social-icons') || node.querySelector('.social-icons'))) {
                hasChanges = true;
                break;
              }
            }
          }
        }

        if (hasChanges) {
          // Attendre un peu pour que AddToAny finisse de charger
          setTimeout(function() {
            processSocialIcons();
          }, 100);
        }
      });
      observer.observe($hidden[0], {
        childList: true,
        subtree: true
      });
    }

    // Aussi vérifier après le chargement complet de la page
    jQuery(window).on('load', function () {
      setTimeout(function() {
        processSocialIcons();
      }, 500);
    });

    // Fonction pour basculer l'état
    var toggleShare = function() {
      var isCurrentlyOpen = $shareLink.hasClass('opened');

      if (isCurrentlyOpen) {
        $shareLink.removeClass('opened').addClass('closed');
        $button.attr('aria-expanded', 'false');
        $hidden.attr('aria-hidden', 'true');
        updateAccessibleText(false);
      } else {
        $shareLink.removeClass('closed').addClass('opened');
        $button.attr('aria-expanded', 'true');
        $hidden.attr('aria-hidden', 'false');
        updateAccessibleText(true);
      }
    };

    // Gestion du clic
    $button.on('click', function (e) {
      e.preventDefault();
      toggleShare();
    });

    // Support clavier selon le pattern Disclosure ARIA
    $button.on('keydown', function (e) {
      // Space ou Enter pour activer (géré par défaut pour les boutons)
      // Escape pour fermer si ouvert
      if ((e.key === 'Escape' || e.key === 'Esc') && $shareLink.hasClass('opened')) {
        e.preventDefault();
        toggleShare();
        // Le focus reste sur le bouton après fermeture
        $button.focus();
      }
    });


    jQuery(window).on('load', function () {
      jQuery('body').addClass('loaded');
    });

  },

  detach: function(context, settings) {}
});
